import React, { useState } from "react";
import ByPanelChart from "../ByPanelChart";
import ByPanelDatePicker from "../DatePicker";
import ByPanelDailyChartData from "../ByPanelChart";
import { Button } from "antd";
import { SyncOutlined } from "@ant-design/icons";
import RangePickerEvents from "../RangePicker";
import moment from "moment-jalaali";

const DailyTab = ({
  dailyChartData,
  setDateHOC,
  dateHOC,
  loadingDailyChart,
  setRefresh,
  lang_choiced
}) => {

  return (
    <div>
      <div className="text-center">
        <RangePickerEvents
          key="RangePickerOptimizer"
          setDatesHOC={(date) => {
         
            // console.log([
            //   moment(date[0], "jYYYY-jMM-jDD").format("YYYY-MM-DD"),
            //   moment(date[1], "jYYYY-jMM-jDD").format("YYYY-MM-DD"),
            // ]);
            setDateHOC([
              moment(date[0], "jYYYY-jMM-jDD").format("YYYY-MM-DD"),
              moment(date[1], "jYYYY-jMM-jDD").format("YYYY-MM-DD"),
            ]);
          }}
          dateHOC={dateHOC}
          isPanel
          lang_choiced={lang_choiced}
        />
        {/* <ByPanelDatePicker
          dateHOC={dateHOC}
          setDateHOC={(date) => {
            // console.log(date , "by panel date")
            setDateHOC(date);
          }}
        /> */}
      </div>
      <Button
        className="mt-2"
        onClick={() => {
          setRefresh();
        }}
        icon={<SyncOutlined size={256} />}
        type="link"
      >
        {lang_choiced.pages.byPanel.PanelGroup.Line.Modal.chartTab.btnUpdate}
      </Button>
      {/* <ByPanelChart data={dailyChartData} /> */}
      <ByPanelDailyChartData
        data={dailyChartData}
        dateHOC={dateHOC}
        loading={loadingDailyChart}
       
      />
    </div>
  );
};

export default React.memo(DailyTab);
